import CategoryHeader from './CategoryHeader';

export default CategoryHeader;

export const componentName = 'CategoryHeader';
